"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Link = {
    baseStyle: {
        fontSize: 'md',
    },
};
exports.default = Link;
